export default __webpack_public_path__ + "static/media/560.07782d14.gif";